import React from 'react';
import { Tag } from 'antd';

const SUGGESTIONS = [
  'Zeige mir alle Schulhäuser im Kanton Zürich',
  'Durchschnittliche Kosten pro m² GF für Wohnbauten',
  'Vergleiche die eBKP-C-Kosten der grössten Gesundheitsbauten als Diagramm',
  'Welche Projekte haben Fernwärme?',
];

const SuggestionChips = ({ onSelect, disabled }) => (
  <div className="agent-suggestions">
    {SUGGESTIONS.map((suggestion) => (
      <Tag
        key={suggestion}
        className="agent-suggestion-chip"
        onClick={() => !disabled && onSelect(suggestion)}
      >
        {suggestion}
      </Tag>
    ))}
  </div>
);

export default SuggestionChips;
